import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom';
// import { getData } from '../../actions';
// import { ERROR_AUTH } from '../../actions/types';
import { useHistory } from "react-router-dom";

import { useGlobalContext } from '../../context/GlobalContext';

import styles from './Auth.module.scss';

export default function IndexPage() {

  const history = useHistory();

  const context = useGlobalContext()[0];

  async function ssoConnect() {
    // let url = "/auth/login-saml";
  
    // await getData(ERROR_AUTH, url, dispatch , false ).then((response) => {
    //   ssoLogin = response
    // });
    const token = "test"
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.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.RKkgVNMucViY37jCv4kLV1O8LuSRTb55LAWI1Pa3bsg';
    console.log(token);
    history.push(`/sso/${token}`)
  }

  return (
    <div className={styles.login}>

      <div className={styles['col-img']}></div>

      <div className={styles['col-form']}>

        <p className={`${styles.title} bold`}>
          <span className={`${styles.name} bold`} >BIBLIOCTA</span><br/>
          <span className="regular">BY </span><span>octapharma</span>
        </p>

        <div className={styles.sso}>
        <button
          className={`${styles.btn} ${styles.primary}`}
          type="button"
          onClick={() => ssoConnect()}
        >
          Log through SSO
        </button>
        <Link to="/login">
          <button
            className={`${styles.btn} ${styles.primary}`}
            type="button"
          >
            Log with password
          </button>
        </Link>
        </div>
        {context.auth.errorLogin === "You are not authorized to consult BIBLIOCTA" &&
          <p className="text-error text-center">{context.auth.errorLogin}</p>
        }
      </div>

    </div>
  )
}
